import { normalizeParentMe } from '@/helper/parentNormalize';

const outlet = { id: 2, name: 'Demo Outlet' };

const childA = {
	id: 10,
	member: {
		id: 342,
		name: 'BUDIARJO Aurelia Safira',
		on_list_attributes: {
			class: 'Kinder A',
			student_id: '24024',
			customer_type: 'Student',
			dietary_preferences: [],
			contact: null,
		},
	},
	outlet,
	balance: '301500.000',
	is_active: true,
	family_is_active: true,
};

const childB = {
	id: 6,
	member: {
		id: 353,
		name: 'BALA SUBRAMANIAM Kaira',
		on_list_attributes: {
			class: 'Kinder B',
			student_id: null,
			customer_type: 'Student',
			dietary_preferences: [],
			contact: null,
		},
	},
	outlet,
	balance: '2500.000',
	is_active: false,
	family_is_active: false,
};

/** Active child with balance but no meal orders (top-up only) → not_ordered. */
const childTopUpOnly = {
	id: 12,
	member: {
		id: 360,
		name: 'Top Up Only Student',
		on_list_attributes: {
			class: 'Kinder A',
			student_id: '24099',
			customer_type: 'Student',
			dietary_preferences: [],
			contact: null,
		},
	},
	outlet,
	balance: '50000.000',
	is_active: true,
	family_is_active: true,
	_fixture: 'topup_only',
};

const parentUser = {
	id: 337,
	name: 'mother',
	email: 'mother@exampleparent.com',
	username: 'mother@exampleparent.com_customer-dev',
	is_active: true,
};

/** Fixtures matching Postman / D1 contract shapes (0 / 1 / 2 children). */
export const mockParentMeFixtures = {
	parentZeroChildren: normalizeParentMe({
		account_type: 'parent',
		user: parentUser,
		customer: null,
		outlet,
		children: [],
	}),
	parentOneChild: normalizeParentMe({
		account_type: 'parent',
		user: parentUser,
		customer: null,
		outlet,
		children: [childA],
	}),
	parentTwoChildren: normalizeParentMe({
		account_type: 'parent',
		user: parentUser,
		customer: null,
		outlet,
		children: [childA, childB],
	}),
	legacyOneChild: normalizeParentMe({
		account_type: 'legacy',
		user: { ...parentUser, name: 'Legacy Student' },
		customer: childA,
		outlet,
		children: [childA],
	}),
};

function enrichDashboardChild(child, index) {
	if (!child.is_active) {
		return {
			...child,
			status: 'inactive',
			serving_times: [],
		};
	}

	if (child._fixture === 'topup_only') {
		const rest = { ...child };
		delete rest._fixture;
		return {
			...rest,
			status: 'not_ordered',
			serving_times: [],
		};
	}

	// Varied statuses for multi-child demos / acceptance
	if (index === 0) {
		return {
			...child,
			status: 'ordered',
			serving_times: [
				{ name: 'Lunch', quantity: 1 },
				{ name: 'Snack', quantity: 0 },
			],
		};
	}
	if (index === 1) {
		return {
			...child,
			status: 'not_ordered',
			serving_times: [],
		};
	}
	return {
		...child,
		status: 'cancelled',
		serving_times: [{ name: 'Lunch', quantity: 0, is_void: true }],
	};
}

/**
 * Dashboard mock contract: date, generated_at, summary, every child including zero orders.
 * Pass live `children` from me/ when available; falls back to demo roster.
 */
export function mockParentDashboard(date, children) {
	const day = date || new Date().toISOString().slice(0, 10);
	// Explicit empty array = zero children (do not substitute demo roster).
	const source = Array.isArray(children)
		? children
		: [childA, { ...childTopUpOnly }, childB];

	const rows = source.map((c, i) => enrichDashboardChild(c, i));

	const summary = {
		ordered: rows.filter((c) => c.status === 'ordered').length,
		not_ordered: rows.filter((c) => c.status === 'not_ordered').length,
		cancelled: rows.filter((c) => c.status === 'cancelled').length,
		inactive: rows.filter((c) => c.status === 'inactive').length,
	};

	return {
		date: day,
		generated_at: new Date().toISOString(),
		summary,
		children: rows,
	};
}

export { childA, childB, childTopUpOnly };
